<script setup lang="ts">
const props = withDefaults(defineProps<Props>(), {
  options: undefined,
  dfpId: '21658289790,22466679900',
  dfpAdUnitPath: undefined,
  sizes: undefined,
  sizeMapping: undefined,
  customClass: '',
})

// Global setting: always show boundaries for ad placement visualization (reserved for debug)
const _showBoundaries = true

interface Props {
  options?: string | Record<string, any>
  dfpId?: string
  dfpAdUnitPath?: string
  sizes?: (number | number[])[]
  sizeMapping?: any[]
  customClass?: string
}

// Parse options object if string
const parsedOptions = computed(() => {
  if (!props.options) {
    return null
  }
  if (typeof props.options === 'string') {
    try {
      return JSON.parse(props.options)
    }
    catch {
      return null
    }
  }
  return props.options
})

// Build ad options from individual props
function buildAdOptions() {
  const options: Record<string, any> = {}

  if (props.dfpId) {
    options.dfpId = props.dfpId
  }

  if (props.dfpAdUnitPath) {
    options.dfpAdUnitPath = props.dfpAdUnitPath
  }

  if (props.sizes) {
    options.sizes = props.sizes
  }

  if (props.sizeMapping) {
    options.sizeMapping = props.sizeMapping
  }

  return options
}

// Get final options for rendering
function getFinalOptions() {
  if (parsedOptions.value) {
    return parsedOptions.value
  }
  return buildAdOptions()
}

// Convert options to JSON string
function optionsJson(opts: any) {
  if (!opts || Object.keys(opts).length === 0) {
    return ''
  }
  return JSON.stringify(opts)
}

const LazyAdExplanationModal = defineAsyncComponent(() => import('~/components/modals/AdExplanationModal.vue'))
const overlay = useOverlayWithAd()
const baseStore = useBaseStore()

function openAdExplanationModal() {
  const modal = overlay.create(LazyAdExplanationModal)
  modal.open()
}

onMounted(() => {
  // eslint-disable-next-line no-console
  console.log('[madops] DisplayAd mounted')
  baseStore.scheduleMadopsReset()
})
</script>

<template>
  <div
    class="p-0 flex flex-col"
    :class="[customClass]"
  >
    <div class="flex justify-center mb-0.5">
      <UButton
        variant="ghost"
        color="neutral"
        size="xs"
        label="PUBLICITÉ"
        class="text-xs text-poivre-500 hover:underline font-normal p-0"
        @click="openAdExplanationModal"
      />
    </div>
    <div
      :data-m32-ad="true"
      :data-options="optionsJson(getFinalOptions())"
      class="flex items-center justify-center overflow-hidden"
    />
  </div>
</template>
